import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewChild } from '@angular/core'
import { NgScrollbar } from 'ngx-scrollbar'
import dayjs from 'dayjs'

import { ChatMessageGroup, ChatMessageModel } from '@shared/models/messenger/messenger.model'
import { User } from '@shared/models/user.model'
import { MessengerService } from '../../services/messenger.service'

@Component({
  selector: 'lin-chat-message-list',
  templateUrl: './chat-message-list.component.html',
  styleUrls: ['./chat-message-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatMessageListComponent {
  @Input() currentUser: User
  @Input() chatMessageList: ChatMessageModel[]
  @Input() isGroupChat: boolean
  @Input() isMyChat: boolean

  @ViewChild('perfectScrollbar', { static: false }) perfectScrollbar?: NgScrollbar
  @HostBinding('class.attachment') @Input() isAttachment: boolean

  constructor(public readonly messengerService: MessengerService) {}

  trackBy(_, { id, updatedAt }: ChatMessageModel): string {
    return `${dayjs(updatedAt).valueOf()}-${id}`
  }

  trackByGroup(_, group: ChatMessageGroup): number {
    return dayjs(group.chatMessageList[0].createdAt).valueOf()
  }
}
